<ng-container *transloco="let t">
  <div class="dialog-overlay" (click)="onOverlayClick($event)">
    <section
      class="dialog-container"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleId"
      [attr.aria-describedby]="descriptionId"
      cdkTrapFocus
      cdkTrapFocusAutoCapture
      (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="dialog-header">
        <h2 class="dialog-title" [id]="titleId">{{ t('lang.cancel_dialog_title') }}</h2>
      </div>

      <!-- Content -->
      <div class="dialog-content">
        <p class="dialog-subtitle" [id]="descriptionId">{{ t('lang.cancel_dialog_message') }}</p>
      </div>

      <!-- Footer -->
      <div class="dialog-footer">
        <button
          type="button"
          class="danger-button"
          [disabled]="loading"
          (click)="onConfirm()">
          @if (loading) {
            <mzic-spinner />
          }
          {{ t('lang.cancel_dialog_confirm') | uppercase }}
        </button>
        <button
          #backButton
          type="button"
          class="secondary-button"
          cdkFocusInitial
          [disabled]="loading"
          (click)="onCancel()">
          {{ t('lang.cancel_dialog_back') | uppercase }}
        </button>
      </div>
    </section>
  </div>
</ng-container>
